// SmazatUcet.js
import React, { useRef, useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from './contexts/AuthContext';
import styled from 'styled-components';

const SmazatUcet = ({ onClose }) => { // Změněno jméno props na onClose
    const { user, deleteUser } = useAuth();
    const inputRef = useRef(null);
    const [serverError, setServerError] = useState('');

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const formik = useFormik({
        initialValues: {
            confirm: ''
        },
        validationSchema: Yup.object({
            confirm: Yup.string()
                .required('Musíte potvrdit smazání účtu.')
                .oneOf(['Smazat'], 'Musíte zadat "Smazat" pro potvrzení.')
        }),
        onSubmit: async (values) => {
            if (!user) {
                console.error('Není přihlášen žádný uživatel.');
                setServerError('Není přihlášen žádný uživatel.');
                return;
            }

            try {
                console.log('Snažím se smazat uživatele:', user.uid);
                await deleteUser();
                console.log('Účet úspěšně smazán');
                if (typeof onClose === 'function') {
                    console.log('Zavírám modální okno');
                    onClose(); // Zavřít modální okno po úspěšném smazání
                } else {
                    console.warn('onClose není funkce');
                }
            } catch (error) {
                console.error('Chyba při mazání účtu:', error);
                setServerError('Došlo k chybě při mazání účtu.');
            }
        }
    });

    const handleCloseModal = () => {
        if (typeof onClose === 'function') {
            console.log('Zavírám modální okno');
            onClose();
        } else {
            console.warn('onClose není funkce');
        }
    };

    return (
        <PopupCard>
            <PopupTitle>Potvrzení smazání účtu</PopupTitle>
            <form onSubmit={formik.handleSubmit}>
                <ModalInput 
                    type="text"
                    {...formik.getFieldProps('confirm')}
                    placeholder="Zadejte 'Smazat' pro potvrzení"
                    ref={inputRef}
                    autoComplete="off"
                    autoCorrect="off"
                />
                {formik.touched.confirm && formik.errors.confirm ? (
                    <ErrorText>{formik.errors.confirm}</ErrorText>
                ) : null}
                {serverError && (
                    <ErrorText>{serverError}</ErrorText>
                )}
                <PopupButtons>
                    <PopupButton type="submit">Smazat účet</PopupButton>
                    <PopupButton variant="secondary" type="button" onClick={handleCloseModal}>Zavřít</PopupButton>
                </PopupButtons>
            </form>
        </PopupCard>
    );
};

// Stylované komponenty
// Popup card styles (match header/user profile popups)
const PopupCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 520px;
    max-width: calc(100vw - 48px);
    padding: 18px 20px;
    border-radius: 12px;
    box-sizing: border-box;
    background: #071014;
    color: #fff;
    border: 1px solid rgba(255,255,255,0.04);
    box-shadow: 0 20px 60px rgba(0,0,0,0.6);
`;

const PopupTitle = styled.h2`
    margin: 6px 0 12px 0;
    font-size: 20px;
    text-align: left;
    font-weight: 700;
`;

const ModalInput = styled.input`
    margin-bottom: 8px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.08);
    width: 100%;
    max-width: 100%;
    font-size: 16px;
    box-sizing: border-box;
    background: rgba(255,255,255,0.02);
    color: #fff;
    &:focus { border-color: #e74c3c; box-shadow: 0 6px 18px rgba(231,76,60,0.06); outline:none; }
`;

const ErrorText = styled.p`
    color: #ff6b6b;
    margin: 4px 0;
    font-size: 14px;
    text-align: left;
`;

const PopupButtons = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    margin-top: 18px;
`;

const PopupButton = styled.button`
    background: ${props => props.variant === 'secondary' ? '#2b2f33' : '#e74c3c'};
    border: none;
    color: #fff;
    padding: 10px 18px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 700;
    transition: transform .12s ease, filter .12s ease;
    &:hover { filter: brightness(1.06); transform: translateY(-2px); }
`;

export default SmazatUcet;
